import { IonImg, IonContent, IonHeader, IonGrid, IonRow, IonCol, IonPage } from '@ionic/react';
import React from 'react';
import ListItemAbout from '../components/ListItemAbout'
import './About.css';
import about_content from '../data/about-data.json'
import Toolbar from 'components/Toolbar';

const About: React.FC = () => {

  return (
    <IonPage>
      <IonHeader>
        <Toolbar title="Sobre" menuBtn={true} infoBtn={true} />
      </IonHeader>

      <IonContent className="ion-padding">
        <IonGrid fixed>
          <IonRow className="ion-justify-content-center ion-margin-bottom">
            <IonCol size="auto">
              <IonImg id="logotipo" className="img" src="assets/imgs/logo.png" />
            </IonCol>
          </IonRow>

          <IonRow className="ion-justify-content-center" >
            <IonCol size-md="6" className="ion-text-center">
              <h1>Colibras - UFRN</h1>
              <p>
                O COLibras é um dicionário colaborativo de Libras. Nele os sinais podem ser adicionados e acessados por qualquer pessoa. Acesse os sinais e contribua para aumentar nosso vocabulário.
              </p>
            </IonCol>
          </IonRow>

          <div>
            <ListItemAbout title="Laboratórios" items={about_content.laboratories} />

            <h3>Equipe</h3>

            <ListItemAbout title="Coordenador Geral" items={about_content.generalCoordinator} />

            <ListItemAbout title="Colaboradores" items={about_content.contributors} />

            <ListItemAbout title="Desenvolvedores" items={about_content.developers} />

            <ListItemAbout title="Créditos" items={about_content.credits} />

          </div>

        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default About;
